import Description from "./Description";
import Details from "./Details";
import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom";
import { itemApi } from "../../api"; // senin API servis dosyan



import Footer from "../components/Footer";
import Header from "../components/Header";
import MetaComponent from "../components/MetaComponent";
import Products from "../home/Products";


const metadata = {
    title: `Product Details || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function ProductDetailPage({ onPageReady }) {
    const { slug } = useParams(); // ✅ Doğru
    const [product, setProduct] = useState(null);
    const [relatedReady, setRelatedReady] = useState(false);



    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const res = await itemApi.getItemBySlug(slug);
                setProduct(res.data);
            } catch (err) {
                console.error("Ürün detay alınamadı:", err);
            }
        };

        fetchProduct();
    }, [slug]);

    useEffect(() => {
        if (product && relatedReady) {
            onPageReady?.(); // ✅ Her şey hazır olunca sinyali gönder
        }
    }, [product, relatedReady]);


    // const product = allProducts.find((p) => p.slug === slug) || allProducts[0];

    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <Details product={product} />
            <Products
                cardStyleClass="grid style-2"
                tooltipDirection={"top"}
                onLoaded={() => setRelatedReady(true)} // ✅ ürünler geldi
            />
            <Footer paddingBottom />
        </>
    );
}
